import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import { RootState } from '../../models/RootState';
import ContentCopy from '../../assets/images/sportsbook/icons/content-copy.svg';
import deposit from '../../assets/images/common/icons/deposit.png';
import gpay from '../../assets/images/common/icons/gpay.svg';
import paytm from '../../assets/images/common/icons/paytm.svg';
import phonepay from '../../assets/images/common/icons/phonepay.svg';
import TabPanel from '../../components/TabPanel/TabPanel';
import { Tabs, Tab, Button, TextField } from '@material-ui/core';
import bank from '../../assets/images/common/icons/bank.svg';
import './Payment.scss';
import './Deposit.scss';
import NumberFormat from 'react-number-format';
import AGPAY_API from '../../api-services/feature-api';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import Spinner from '../../components/Spinner/Spinner';
import { getUsernameFromToken, setOpenDepositModal } from '../../store';
import { AccountDetails } from './AccountDetails';
import { useHistory } from 'react-router';
import { IonSpinner } from '@ionic/react';
import QRCode from 'react-qr-code';
import { da } from 'date-fns/locale';
import pay1 from '../../assets/images/common/pay22.png';
import pay2 from '../../assets/images/common/pay33.png';
import pay3 from '../../assets/images/common/pay34.png';
import pay4 from '../../assets/images/common/pay45.png';
import { BRAND_DOMAIN } from '../../constants/Branding';
import ZenpayCrypto from './DepositTabPanels/ZenpayCrypto';
import BlazePe from './DepositTabPanels/Blazepe';

type StoreProps = {
  setOpenDepositModal: Function;
  langData:any;
};

type PaymentDetails = {
  bank_id: string;
  upi_id: string;
  phone_number: string;
  bank_account_number: string;
  bank_account_holder: string;
  ifs_code: string;
  bank_name: string;
  upi_qr: string;
  upi_intent: string;
};

type PaymentOptions = {
  payment_method: string;
  payment_method_details: PaymentDetails;
};

const Deposit: React.FC<StoreProps> = (props) => {
  const { setOpenDepositModal ,langData} = props;
  const [tabValue, setTabValue] = useState<Number>(null);
  const [paymentOption, setPaymentOption] = useState<string>('NEFT');
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [depositAmount, setDepositAmount] = useState<string>();
  const [depositNotes, setDepositNotes] = useState<string>();
  const [referenceId, setReferenceId] = useState<string>();
  const [depositImage, setDepositImage] = useState<string | ArrayBuffer>();
  const [uploadImage, setUploadImage] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [onlinePaymentOption, setOnlinePaymentOption] =
    useState<string>('BANK_TRANSFER');
  const [team1PymtOpt, setTeam1PymtOpt] = useState<string>('BKASH');
  const [mobileNumber, setMobileNumber] = useState<string>();
  const [paymentDetails, setPaymentDetails] = useState<PaymentOptions[]>();
  const [providerRefId, setProviderRefId] = useState<string>();
  const [providersList, setProvidersList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [upiLink, setUpiLink] = useState<string>();
  const [paymentOptionFilter, setPaymentOptionFilter] =
    useState<string>('IMPS');
  const [ocrDepositAmount, setOcrDepositAmount] = useState<string>();
  const [ocrReferenceId, setOcrReferenceId] = useState<string>();
  const hiddenFileInput = useRef(null);
  const banks = [
    { value: 'BKASH', img: pay1 },
    { value: 'ROCKET', img: pay2 },
    { value: 'NAGAD', img: pay3 },
    { value: 'BOKAADA', img: pay4 },
  ];

  const history = useHistory();

  const successToast = (mess: string) => {
    toast.success(
      <div>
        <SuccessIcon /> {mess}
      </div>,
      {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const errorToast = (mess: string) => {
    toast.error(
      <div>
        <ErrorIcon /> {mess}
      </div>,
      {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const getImageDetails = async () => {
    setLoading(true);
    setDepositAmount('');
    setOcrDepositAmount('');
    setReferenceId('');
    setOcrReferenceId('');
    try {
      const payload = {
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        image: depositImage,
      };

      const response = await AGPAY_API.post(
        `/agpay/v2/ocr/get-details`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          timeout: 20000,
        }
      );

      if (response.status === 200 && response?.data) {
        const data = response.data;
        const amount = data.amount.trim();
        const utr = data.utr.trim();

        setDepositAmount(amount);
        setOcrDepositAmount(amount);
        setReferenceId(utr);
        setOcrReferenceId(utr);

        if (amount === '' || utr === '') {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['details_entered_success_txt']);
        }
      } else {
        errorToast(langData?.['general_err_txt']);
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const getUtr = async () => {
    setLoading(true);
    setReferenceId('');
    setOcrReferenceId('');
    try {
      const payload = {
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        image: depositImage,
      };

      const response = await AGPAY_API.post(`/agpay/v2/ocr/get-utr`, payload, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        timeout: 20000,
      });

      if (response.status === 200 && response?.data) {
        var utr = response.data;
        setReferenceId(utr);
        setOcrReferenceId(utr);
        if (utr === '') {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['utr_entered_success_txt']);
        }
      } else {
        errorToast('Something went wrong.');
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      depositImage !== undefined &&
      depositImage !== null &&
      depositImage !== ''
    ) {
      if (tabValue === 1) {
        getImageDetails();
      } else if (tabValue === 0) {
        getUtr();
      }
    }
  }, [depositImage]);

  const fetchPaymentMethod = async () => {
    try {
      const response = await AGPAY_API.get(`/agpay/v2/pgman/payment-methods`, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          admin: true,
          paymentOption:
            paymentOption === 'GPAY' || paymentOption === 'PHONEPE'
              ? 'UPI'
              : paymentOption === 'CRYPTO_WALLET_TRANSFER' ? 'CRYPTO_WALLET'
              : paymentOption,
        },
      });
      if (response.status === 200) {
        let accountsArr = [];
        response.data.map((i) => {
          if (!i.disabled) accountsArr.push(i);
        });
        setAccountDetails(accountsArr);
        const initialSelectedAccount = accountsArr[0];
        setSelectedAccount(initialSelectedAccount);
        setSelectedAccountId(initialSelectedAccount?.id?.toString());
      } else {
      }
    } catch (error) {}
  };

  const getPaymentProviders = async () => {
    setLoading(true);
    const accountId = sessionStorage.getItem('aid');
    try {
      const response = await AGPAY_API.get(
        `/agpay/v2/payment-settings/accounts/${accountId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        setProvidersList(response?.data?.deposit_provider_list);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (providersList?.length > 0) {
      if (providersList[0] === 'ABCMONEY') setTabValue(0);
      else if (providersList[0] === 'PGMAN') setTabValue(1);
      else if (providersList[0] === 'SHARKPE') setTabValue(2);
      else if (providersList[0] === 'TRUSTLYPAY') setTabValue(3);
      else if (providersList[0] === 'ZENPAY') setTabValue(4);
      else if (providersList[0] === 'ZENPAYCRYPTO') setTabValue(5);
      else if (providersList[0] === 'BLAZEPE') setTabValue(6);
    }
  }, [providersList]);

  useEffect(() => {
    if (paymentOption === 'NEFT') {
      fetchPaymentMethod();
    }
    setDepositNotes('');
    setDepositAmount('');
    setAccountDetails([]);
    setPaymentOption('NEFT');
    setSelectedAccountId('');
    setOnlinePaymentOption('BANK_TRANSFER');
    setPaymentOptionFilter('IMPS');
  }, [tabValue]);

  useEffect(() => {
    getPaymentProviders();
  },[]);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!depositImage) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['upload_txn_img_txt']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    } else if (Number(depositAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['min_deposit_amount_txt']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: Number(depositAmount),
        notes: depositNotes,
        reference_id: referenceId,
        payment_method_id: selectedAccountId,
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        amount_modified: ocrDepositAmount !== depositAmount,
        reference_id_modified: ocrReferenceId !== referenceId,
      };
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append('request', JSON.stringify(payload));
      const response = await AGPAY_API.post(
        `/agpay/v2/pgman/transactions/:deposit`,
        formData,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        window.location.href = '/my_transactions';
        setOpenDepositModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {response?.data?.message}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const handleCapture = ({ target }) => {
    setUploadImage(target.files[0]);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(target.files[0]);
    fileReader.onload = (e) => {
      setDepositImage(e.target.result);
    };
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const submitOnlineAmount = async (e, selectedPaymentGateway = 'abcmoney') => {
    e.preventDefault();
    if (mobileNumber?.length != 10) {
      toast.error(langData?.['invalid_mobile_no_txt']);
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        currency_type: 'INR',
        mobile_number: mobileNumber,
        notes: depositNotes,
        payment_method:
          onlinePaymentOption === 'UPI' ? 'UPI_TRANSFER' : onlinePaymentOption,
        upi_intent: onlinePaymentOption === 'UPI',
        upi_qr: onlinePaymentOption === 'UPI',
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/${selectedPaymentGateway}/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200) {
        if (response.data.payment_options?.length > 0) {
          setPaymentDetails(response.data.payment_options);
          setProviderRefId(response.data.provider_ref_id);
        }
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const submitSharkpeDeposit = async (e) => {
    e.preventDefault();
    if (mobileNumber?.length != 10) {
      toast.error(langData?.['invalid_mobile_no_txt']);
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        email: 'support@mail.com',
        mobileNumber: mobileNumber,
        notes: depositNotes,
        name: getUsernameFromToken(),
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/sharkpe/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 && response.data) {
        console.log(response.data.paymentLink);
        window.location.replace(response.data.paymentLink);
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const submitBlazepeDeposit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        name: getUsernameFromToken(),
        redirectUrl: window.location.href,
        mobileNumber: mobileNumber,
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/blazepe/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 && response.data) {
        console.log(response.data.paymentLink);
        window.location.replace(response.data.paymentLink);
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const submitTrustPayDeposit = async (e) => {
    e.preventDefault();
    if (mobileNumber?.length != 10) {
      toast.error(langData?.['invalid_mobile_no_txt']);
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        email: 'support@mail.com',
        mobileNumber: mobileNumber,
        notes: depositNotes,
        name: getUsernameFromToken(),
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/trustlypay/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 && response.data) {
        setUpiLink(response.data.paymentLink);
        setProviderRefId(response.data.referenceId);
      }
      setLoading(false);
    } catch (error) {
      console.log(error?.response);
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const confirmPayment = async (e, selectedPaymentGateway = 'abcmoney') => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        gateway_provider_reference_id: providerRefId,
        utr: referenceId,
        mobile_number: mobileNumber,
        bank_id: paymentDetails?.filter(
          (i) => i?.payment_method === onlinePaymentOption
        )[0].payment_method_details?.bank_id,
        payment_option:
          onlinePaymentOption === 'BANK_TRANSFER' ? 'IMPS' : 'UPI',
        reference_id_modified: ocrReferenceId !== referenceId,
        upi_intent: !!paymentDetails?.filter(
          (i) => i?.payment_method === onlinePaymentOption
        )[0]?.payment_method_details?.upi_intent,
      };
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append('request', JSON.stringify(payload));
      const response = await AGPAY_API.post(
        `/agpay/v2/${selectedPaymentGateway}/:confirm-payment`,
        selectedPaymentGateway == 'abcmoney' ? formData : payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status == 200) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        window.location.href = '/my_transactions';
        setOpenDepositModal(false);
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const generateValidUpiLink = (upiLink: string) => {
    if (upiLink) {
      let paramsList = [];
      const url = new URL(upiLink);
      const params = new URLSearchParams(url.search);
      params.forEach((v: string, k: string) => {
        console.log('upi', k, v);
        paramsList.push(`${k}=${v}`);
      });
      return `upi://pay?${paramsList.join('&')}`;
    }
    return '';
  };

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(langData?.['text_copied_txt']);
  };

  useEffect(() => {
    if (paymentOption) {
      fetchPaymentMethod();
      setAccountDetails([]);
      setSelectedAccountId('');
      setDepositAmount('');
      setDepositImage('');
      setDepositNotes('');
      setReferenceId('');
    }
  }, [paymentOption]);

  useEffect(() => {
    setPaymentDetails([]);
    setDepositAmount('');
    setDepositNotes('');
    setReferenceId('');
    setMobileNumber('');
    setProviderRefId('');
  }, [onlinePaymentOption, tabValue]);

  const getPaymentDetails = () => {
    let pd = paymentDetails?.find(
      (i) =>
        i?.payment_method === onlinePaymentOption
    )?.payment_method_details?.upi_intent;
    return pd ? pd : "";
  }

  return (
    <div className="reports-ctn payment-deposit-ctn">
      {loading ? <Spinner /> : null}
      <div className="header-ctn my-wallet-header">
        <IonRow>
          <div className="img-page-title-row mob-view">
            <img className="title-image" src={deposit} />
            <div className="title">{langData?.['deposit']}</div>
          </div>
          <div className="mob-view">
            <Button
              onClick={(e) => {
                history.push('/transaction/withdraw');
              }}
              className="withdraw-deposit-btn actions-btn mob-view"
            >
              {langData?.['withdraw']}
            </Button>
          </div>
        </IonRow>

        <div className="deposit-form-ctn">
          {providersList?.length > 1 && (
            <Tabs
              value={tabValue}
              onChange={(_, newValue) => {
                setTabValue(newValue);
              }}
            >
              {providersList?.includes('ABCMONEY') && (
                <Tab value={0} label={`Option ${providersList.indexOf('ABCMONEY')+1}`} className="payment-btn" />
              )}
              {providersList?.includes('PGMAN') && (
                <Tab value={1} label={`Option ${providersList.indexOf('PGMAN')+1}`} className="payment-btn" />
              )}
              {providersList?.includes('SHARKPE') && (
                <Tab value={2} label={`Option ${providersList.indexOf('SHARKPE')+1}`} className="payment-btn" />
              )}
              {providersList?.includes('TRUSTLYPAY') && (
                <Tab value={3} label={`Option ${providersList.indexOf('TRUSTLYPAY')+1}`} className="payment-btn" />
              )}
              {providersList?.includes('ZENPAY') && (
                <Tab value={4} label={`Option ${providersList.indexOf('ZENPAY')+1}`} className="payment-btn" />
              )}
              {providersList?.includes('ZENPAYCRYPTO') && (
                <Tab value={5} label="Crypto" className="payment-btn" />
              )}
              {providersList?.includes('BLAZEPE') && (
                <Tab value={6} label={`Option ${providersList.indexOf('BLAZEPE')+1}`} className="payment-btn" />
              )}
            </Tabs>
          )}

          <TabPanel className="deposit-tab-panel" value={tabValue} index={0}>
            {providersList?.length > 0 ? (
              <>
                <div className="payment-option-title mt-10">
                {langData?.['choose_payment_option']}
                </div>
                {BRAND_DOMAIN.toLowerCase().includes('team1.live') ? (
                  <Tabs
                    value={team1PymtOpt}
                    onChange={(_, newValue) => {
                      setTeam1PymtOpt(newValue);
                    }}
                  >
                    {banks.map((bank) => (
                      <Tab
                        className="deposit-bank-tab"
                        value={bank.value}
                        label={<img src={bank.img} />}
                      />
                    ))}
                  </Tabs>
                ) : (
                  <Tabs
                    value={onlinePaymentOption}
                    onChange={(_, newValue) => {
                      setOnlinePaymentOption(newValue);
                    }}
                  >
                    <Tab value={'BANK_TRANSFER'} label={langData?.['bank']} />
                    <Tab value={'UPI'} label={langData?.['upi']}/>
                  </Tabs>
                )}
                {onlinePaymentOption && (
                  <form
                    className="account-inputs"
                    onSubmit={(e) => submitOnlineAmount(e)}
                  >
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? 'disabled acc-input'
                            : 'acc-input'
                        }
                        placeholder={langData?.['enter_deposit_amount_txt']}
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                        decimalSeparator={false}
                        disabled={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? true
                            : false
                        }
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_mobile_no']}</div>
                      <NumberFormat
                        required
                        className={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? 'disabled acc-input'
                            : 'acc-input'
                        }
                        placeholder={langData?.['enter_mobile_no']}
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        decimalSeparator={false}
                        disabled={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? true
                            : false
                        }
                      />
                    </div>
                    {!providerRefId && (
                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['next']}
                      </Button>
                    )}
                  </form>
                )}

                {paymentDetails?.length > 0 &&
                  paymentDetails[0]?.payment_method && (
                    <form
                      className="account-inputs"
                      onSubmit={(e) => confirmPayment(e)}
                    >
                      <div className="payment-option-title mt-10">
                      {langData?.['account_details']}
                      </div>

                      {paymentDetails?.length > 0 &&
                        paymentDetails[0]?.payment_method &&
                        onlinePaymentOption === 'BANK_TRANSFER' && (
                          <div className="account-inputs">
                            <div className="account-input">
                              <div className="payment-detail">
                              {langData?.['account_holder_name']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details
                                        ?.bank_account_holder
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details
                                      ?.bank_account_holder
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['account_holder_number']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details
                                        ?.bank_account_number
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details
                                      ?.bank_account_number
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['account_ifsc_code']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.ifs_code
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details?.ifs_code
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['bank_name']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.bank_name
                                    )
                                  }
                                >
                                  {paymentDetails?.filter(
                                    (i) =>
                                      i?.payment_method === onlinePaymentOption
                                  )[0]?.payment_method_details?.bank_name ??
                                    '--'}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      {onlinePaymentOption === 'UPI' && (
                        <div className="account-inputs">
                          <div className="account-input">
                            <div
                              style={{
                                height: 'auto',
                                margin: '0 auto 10px',
                                maxWidth: 200,
                                width: '100%',
                              }}
                            >
                              <QRCode
                                size={256}
                                style={{
                                  height: 'auto',
                                  maxWidth: '100%',
                                  width: '100%',
                                }}
                                value={`upi://pay?pa=${
                                  paymentDetails?.filter(
                                    (i) =>
                                      i?.payment_method === onlinePaymentOption
                                  )[0]?.payment_method_details?.upi_id
                                }&am=${depositAmount}&tn=pay to eswar&cu=INR&pn=${
                                  paymentDetails?.filter(
                                    (i) =>
                                      i?.payment_method === onlinePaymentOption
                                  )[0].payment_method_details
                                    .bank_account_holder
                                }`}
                                viewBox={`0 0 256 256`}
                              />
                            </div>
                            <div className="payment-detail">
                            {langData?.['upi_id']}:
                              <span
                                title={langData?.['click_to_copy']}
                                className="payment-detail-input"
                                onClick={() =>
                                  copyText(
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details?.upi_id
                                  )
                                }
                              >
                                {
                                  paymentDetails?.filter(
                                    (i) =>
                                      i?.payment_method === onlinePaymentOption
                                  )[0]?.payment_method_details?.upi_id
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="account-input">
                        <div className="account-label">
                        {langData?.['enter_reference_id']}
                        </div>
                        <TextField
                          required
                          className="acc-input"
                          placeholder={langData?.['enter_utr_txt']}
                          value={referenceId}
                          onChange={(e) => setReferenceId(e.target.value)}
                        />
                      </div>

                      {onlinePaymentOption === 'BANK_TRANSFER' && (
                        <div className="account-input">
                          <div className="account-label">
                          {langData?.['select_payment_option']}
                          </div>
                          <select
                            required
                            value={paymentOptionFilter}
                            placeholder={langData?.['select_one']}
                            className="acc-input"
                            onChange={(e) =>
                              setPaymentOptionFilter(e.target.value)
                            }
                          >
                            <option value="IMPS">{langData?.['imps']}</option>
                            <option value="NEFT">{langData?.['neft']}</option>
                            <option value="RTGS">{langData?.['rtgs']}</option>
                          </select>
                        </div>
                      )}

                      <div className="account-input">
                        {depositImage ? (
                          <>
                            <div>
                              <div className="uploaded-image-title">
                                {langData?.['uploaded_image']}
                              </div>
                              <img
                                src={`${depositImage}`}
                                className="deposit-image"
                              />
                            </div>
                          </>
                        ) : null}

                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="raised-button-file-abcmoney"
                          multiple
                          hidden
                          type="file"
                          ref={hiddenFileInput}
                          onChange={(e) => handleCapture(e)}
                        />
                        <Button
                          component="div"
                          className="upload-btn"
                          onClick={handleClick}
                        >
                          {langData?.['upload_image']}
                        </Button>
                      </div>

                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['confirm_payment']}
                      </Button>
                    </form>
                  )}
              </>
            ) : (
              <div>{langData?.['providers_not_found_txt']}</div>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={1} className="payment-options">
            <div className="payment-option-title mt-10">
            {langData?.['choose_payment_option']}
            </div>
            <Button
              className={
                paymentOption === 'NEFT' ? 'active payment-btn' : 'payment-btn'
              }
              onClick={() => setPaymentOption('NEFT')}
            >
              <img
                className={'payment-icon'}
                alt="bank"
                src={bank}
                loading="lazy"
              />
            </Button>
            <Button
              className={
                paymentOption === 'GPAY' ? 'active payment-btn' : 'payment-btn'
              }
              onClick={() => setPaymentOption('GPAY')}
            >
              <img
                className={'payment-icon'}
                alt="gpay"
                src={gpay}
                loading="lazy"
              />
            </Button>
            <Button
              className={
                paymentOption === 'PHONEPE'
                  ? 'active payment-btn'
                  : 'payment-btn'
              }
              onClick={() => setPaymentOption('PHONEPE')}
            >
              <img
                className={'payment-icon'}
                alt="phonepay"
                src={phonepay}
                loading="lazy"
              />
            </Button>
            <Button
              className={
                paymentOption === 'PAYTM_WALLET'
                  ? 'active payment-btn'
                  : 'payment-btn'
              }
              onClick={() => setPaymentOption('PAYTM_WALLET')}
            >
              <img
                className={'payment-icon'}
                alt="paytm"
                src={paytm}
                loading="lazy"
                height={30}
              />
            </Button>

            <div>
              {accountDetails?.length > 0 ? (
                <>
                  {/* <div className="payment-form-divider"></div> */}
                  <div className="account-details-title account-mt-10">
                  {langData?.['choose_beneficiary_account']}
                  </div>
                </>
              ) : null}
              {paymentOption && accountDetails?.length == 0 ? (
                <>
                  <div className="account-details-title account-mt-10">
                  {langData?.['beneficiary_account_not_found_txt']}
                  </div>
                </>
              ) : null}
              <div className="account-details-ctn">
                <Tabs
                  value={1}
                  variant="scrollable"
                  scrollButtons="off"
                  className="actions-list"
                >
                  {accountDetails?.map((acc) =>
                    !acc?.disabled ? (
                      <div className="btn-and-qrcode">
                        <Button
                          className={
                            acc?.id?.toString() === selectedAccountId
                              ? 'active account-detail'
                              : 'account-detail'
                          }
                          onClick={() => {
                            setSelectedAccountId(acc?.id?.toString());
                            setSelectedAccount(acc);
                          }}
                        >
                          <div className="account">
                            <div className="account-name">
                              {acc?.paymentMethodDetails?.accountHolderName}{' '}
                            </div>
                          </div>
                        </Button>
                      </div>
                    ) : null
                  )}
                </Tabs>
              </div>
            </div>

            {!selectedAccount?.disabled ? (
              <div className="btn-and-qrcode">
                <div className={'account-detail'}>
                  <div className="account">
                    <div>
                      {selectedAccount?.paymentMethodDetails?.accountHolderName}{' '}
                    </div>

                    {selectedAccount?.paymentMethodDetails
                      ?.accountHolderName ? (
                      <div
                        className="copy-btn"
                        onClick={(e) => {
                          copyText(
                            selectedAccount?.paymentMethodDetails
                              ?.accountHolderName
                          );
                          e.stopPropagation();
                        }}
                      >
                        <img className="content-copy" src={ContentCopy} />
                      </div>
                    ) : null}
                  </div>
                  <div className="account">
                    <div>
                      {selectedAccount?.paymentMethodDetails?.accountNumber}
                    </div>
                    {selectedAccount?.paymentMethodDetails?.accountNumber ? (
                      <div
                        className="copy-btn"
                        onClick={(e) => {
                          copyText(
                            selectedAccount?.paymentMethodDetails?.accountNumber
                          );
                          e.stopPropagation();
                        }}
                      >
                        <img className="content-copy" src={ContentCopy} />
                      </div>
                    ) : null}
                  </div>
                  <div className="account">
                    {selectedAccount?.paymentMethodDetails?.upiId ? (
                      <>
                        <div>
                        {langData?.['upi_id']} : {selectedAccount.paymentMethodDetails.upiId}
                        </div>
                        <div
                          className="copy-btn"
                          onClick={(e) => {
                            copyText(
                              selectedAccount.paymentMethodDetails.upiId
                            );
                            e.stopPropagation();
                          }}
                        >
                          <img
                            className="content-copy"
                            src={ContentCopy}
                            alt=""
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div className="account">
                    {selectedAccount?.paymentMethodDetails?.phoneNumber ? (
                      <>
                        <div>
                        {langData?.['phone_number']} :{' '}
                          {selectedAccount.paymentMethodDetails.phoneNumber}
                        </div>
                        <div
                          className="copy-btn"
                          onClick={(e) => {
                            copyText(
                              selectedAccount.paymentMethodDetails.phoneNumber
                            );
                            e.stopPropagation();
                          }}
                        >
                          <img
                            className="content-copy"
                            src={ContentCopy}
                            alt=""
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  {paymentOption === 'NEFT' && (
                    <div className="account-ifsc account">
                      <div>
                        {selectedAccount?.paymentMethodDetails?.ifscCode
                          ? `IFSC: ${selectedAccount?.paymentMethodDetails?.ifscCode}`
                          : null}
                      </div>
                      {selectedAccount?.paymentMethodDetails?.ifscCode ? (
                        <div
                          className="copy-btn"
                          onClick={(e) => {
                            copyText(
                              selectedAccount?.paymentMethodDetails?.ifscCode
                            );
                            e.stopPropagation();
                          }}
                        >
                          <img
                            className="content-copy"
                            src={ContentCopy}
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                {selectedAccount?.paymentMethodDetails?.upiId && (
                  <div>
                    <div>
                      <div
                        style={{
                          height: 'auto',
                          margin: '0px',
                          maxWidth: 200,
                          width: '100%',
                        }}
                      >
                        <QRCode
                          size={256}
                          style={{
                            height: 'auto',
                            maxWidth: '100%',
                            width: '100%',
                          }}
                          value={`upi://pay?pa=${selectedAccount?.paymentMethodDetails?.upiId}&tn=pay to eswar&cu=INR&pn=${selectedAccount?.paymentMethodDetails?.accountHolderName}`}
                          viewBox={`0 0 256 256`}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            {selectedAccountId ? (
              <>
                <div className="payment-form-divider"></div>

                <form
                  className="account-inputs"
                  onSubmit={(e) => submitPayment(e)}
                >
                  <div className="account-input-title">
                  {langData?.['enter_payment_details']}
                  </div>

                  {paymentOption === 'NEFT' ? (
                    <div className="account-input">
                      <div className="account-label">{langData?.['select_payment_options']}</div>
                      <select
                        required
                        value={paymentOptionFilter}
                        placeholder={langData?.['select_one']}
                        className="acc-input"
                        onChange={(e) => setPaymentOptionFilter(e.target.value)}
                      >
                        <option value="IMPS">{langData?.['imps']}</option>
                        <option value="NEFT">{langData?.['neft']}</option>
                        <option value="RTGS">{langData?.['rtgs']}</option>
                      </select>
                    </div>
                  ) : null}

                  <div className="account-input">
                    <div className="account-label">
                    {langData?.['enter_amount_verify']}
                    </div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_deposited_amount']}
                      value={depositAmount}
                      onChange={(e) => setDepositAmount(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>

                  <div className="account-input">
                    <div className="account-label">
                    {langData?.['enter_reference_id']}
                    </div>
                    <TextField
                      required
                      placeholder={langData?.['enter_txn_ref_id']}
                      className="acc-input"
                      value={referenceId}
                      onChange={(e) => setReferenceId(e.target.value)}
                    />
                  </div>

                  <div className="account-input">
                    <div className="account-label">{langData?.['enter_notes']}</div>
                    <TextField
                      placeholder={langData?.['enter_notes']}
                      className="acc-input"
                      value={depositNotes}
                      onChange={(e) => setDepositNotes(e.target.value)}
                    />
                  </div>

                  <div className="account-input">
                    {depositImage ? (
                      <>
                        <div className="img-div">
                          <div className="uploaded-image-title">
                          {langData?.['uploaded_image']}
                          </div>
                          <img
                            src={`${depositImage}`}
                            className="deposit-image"
                          />
                        </div>
                      </>
                    ) : null}

                    <input
                      accept="image/*"
                      style={{ display: 'none' }}
                      id="raised-button-file-pgman"
                      multiple
                      hidden
                      type="file"
                      ref={hiddenFileInput}
                      onChange={(e) => handleCapture(e)}
                    />
                    <Button
                      component="div"
                      className="upload-btn"
                      onClick={handleClick}
                    >
                      {langData?.['upload_image']}
                    </Button>
                  </div>

                  <Button
                    id='submit-button'
                    className="submit-payment-btn submit-deposit-btn"
                    type="submit"
                    disabled={loading ? true : false}
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                  >
                    {langData?.['submit']}
                  </Button>
                </form>
              </>
            ) : null}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            {providersList?.length > 0 ? (
              <>
                {onlinePaymentOption && (
                  <form
                    className="account-inputs"
                    onSubmit={(e) => submitSharkpeDeposit(e)}
                  >
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className={'acc-input'}
                        placeholder={langData?.['enter_deposit_amount_txt']}
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                        decimalSeparator={false}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_mobile_no']}</div>
                      <NumberFormat
                        required
                        className={'acc-input'}
                        placeholder={langData?.['enter_mobile_no']}
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        decimalSeparator={false}
                      />
                    </div>
                    {!providerRefId && (
                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['deposit']}
                      </Button>
                    )}
                  </form>
                )}
              </>
            ) : (
              <div>{langData?.['providers_not_found_txt']}</div>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            {providersList?.length > 0 ? (
              <>
                {onlinePaymentOption && (
                  <form
                    className="account-inputs"
                    onSubmit={(e) => submitTrustPayDeposit(e)}
                  >
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className={'acc-input'}
                        placeholder={langData?.['enter_deposit_amount_txt']}
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                        decimalSeparator={false}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_mobile_no']}</div>
                      <NumberFormat
                        required
                        className={'acc-input'}
                        placeholder={langData?.['enter_mobile_no']}
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        decimalSeparator={false}
                      />
                    </div>
                    {!providerRefId && (
                      <Button
                        id='submit-button-deposit'
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['submit']}
                      </Button>
                    )}
                  </form>
                )}
              </>
            ) : (
              <div>{langData?.['providers_not_found_txt']}</div>
            )}
            {providerRefId && (
              <div className="account-inputs">
                <div className="account-input">
                  <div
                    style={{
                      height: 'auto',
                      margin: '0 auto 10px',
                      maxWidth: 200,
                      width: '100%',
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: 'auto',
                        maxWidth: '100%',
                        width: '100%',
                      }}
                      value={generateValidUpiLink(upiLink)}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <div className="payment-detail">
                    <a
                      title={langData?.['tap_to_pay']}
                      href={upiLink}
                      className="payment-detail-input"
                    >
                      {langData?.['pay_using_app']}
                    </a>
                  </div>
                </div>
                <Button
                  className="submit-payment-btn"
                  type="submit"
                  disabled={loading ? true : false}
                  onClick={() => {
                    window.location.href = '/my_transactions';
                  }}
                >
                  {langData?.['close']}
                </Button>
              </div>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            {providersList?.length > 0 ? (
              <>
                <div className="payment-option-title mt-10">
                {langData?.['choose_payment_option']}
                </div>
                <Tabs
                  value={onlinePaymentOption}
                  onChange={(_, newValue) => {
                    setOnlinePaymentOption(newValue);
                  }}
                >
                  <Tab value={'BANK_TRANSFER'} label={langData?.['bank']} />
                  <Tab value={'UPI'} label={langData?.['upi']}/>
                </Tabs>
                {onlinePaymentOption && (
                  <form
                    className="account-inputs"
                    onSubmit={(e) => submitOnlineAmount(e, 'zenpay')}
                  >
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? 'disabled acc-input'
                            : 'acc-input'
                        }
                        placeholder={langData?.['enter_deposit_amount_txt']}
                        value={depositAmount}
                        onChange={(e) => setDepositAmount(e.target.value)}
                        decimalSeparator={false}
                        disabled={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? true
                            : false
                        }
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_mobile_no']}</div>
                      <NumberFormat
                        required
                        className={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? 'disabled acc-input'
                            : 'acc-input'
                        }
                        placeholder={langData?.['enter_mobile_no']}
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        decimalSeparator={false}
                        disabled={
                          paymentDetails?.length &&
                          paymentDetails[0]?.payment_method
                            ? true
                            : false
                        }
                      />
                    </div>
                    {!providerRefId && (
                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['next']}
                      </Button>
                    )}
                  </form>
                )}

                {paymentDetails?.length > 0 &&
                  paymentDetails[0]?.payment_method && (
                    <form
                      className="account-inputs"
                      onSubmit={(e) => confirmPayment(e, 'zenpay')}
                    >
                      <div className="payment-option-title mt-10">
                      {langData?.['account_details']}
                      </div>

                      {paymentDetails?.length > 0 &&
                        paymentDetails[0]?.payment_method &&
                        onlinePaymentOption === 'BANK_TRANSFER' && (
                          <div className="account-inputs">
                            <div className="account-input">
                              <div className="payment-detail">
                                Account Holder Name:
                                <span
                                  title="Click to Copy"
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details
                                        ?.bank_account_holder
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details
                                      ?.bank_account_holder
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['account_holder_number']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details
                                        ?.bank_account_number
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details
                                      ?.bank_account_number
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['account_ifsc_code']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.ifs_code
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details?.ifs_code
                                  }
                                </span>
                              </div>
                              <div className="payment-detail">
                              {langData?.['bank_name']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.bank_name
                                    )
                                  }
                                >
                                  {paymentDetails?.filter(
                                    (i) =>
                                      i?.payment_method === onlinePaymentOption
                                  )[0]?.payment_method_details?.bank_name ??
                                    '--'}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      {onlinePaymentOption === 'UPI' && (
                        <div className="account-inputs">
                          <div className="account-input">
                            <div
                              style={{
                                height: 'auto',
                                margin: '0px',
                                maxWidth: 200,
                                width: '100%',
                              }}
                            >
                              <QRCode
                                size={256}
                                style={{
                                  height: 'auto',
                                  maxWidth: '100%',
                                  width: '100%',
                                }}
                                value={
                                  getPaymentDetails()
                                }
                                viewBox={`0 0 256 256`}
                              />
                            </div>
                            {!paymentDetails?.filter(
                              (i) => i?.payment_method === onlinePaymentOption
                            )[0]?.payment_method_details?.upi_intent ? (
                              <div className="payment-detail">
                                {langData?.['upi_id']}:
                                <span
                                  title={langData?.['click_to_copy']}
                                  className="payment-detail-input"
                                  onClick={() =>
                                    copyText(
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.upi_id
                                    )
                                  }
                                >
                                  {
                                    paymentDetails?.filter(
                                      (i) =>
                                        i?.payment_method ===
                                        onlinePaymentOption
                                    )[0]?.payment_method_details?.upi_id
                                  }
                                </span>
                              </div>
                            ) : null}
                            {paymentDetails?.filter(
                              (i) => i?.payment_method === onlinePaymentOption
                            )[0]?.payment_method_details?.upi_intent ? (
                              <>
                                <Button
                                  className={'active payment-btn'}
                                  onClick={() =>
                                    window.open(
                                      paymentDetails
                                        ?.filter(
                                          (i) =>
                                            i?.payment_method ===
                                            onlinePaymentOption
                                        )[0]
                                        ?.payment_method_details?.upi_intent.replace(
                                          'upi',
                                          'phonpe'
                                        )
                                    )
                                  }
                                >
                                  <img
                                    className={'payment-icon'}
                                    alt="phonepay"
                                    src={phonepay}
                                    loading="lazy"
                                  />
                                </Button>

                                <Button
                                  className={'active payment-btn'}
                                  onClick={() =>
                                    window.open(
                                      paymentDetails
                                        ?.filter(
                                          (i) =>
                                            i?.payment_method ===
                                            onlinePaymentOption
                                        )[0]
                                        ?.payment_method_details?.upi_intent.replace(
                                          'upi://',
                                          'tez://upi/'
                                        )
                                    )
                                  }
                                >
                                  <img
                                    className={'payment-icon'}
                                    alt="gpay"
                                    src={gpay}
                                    loading="lazy"
                                  />
                                </Button>

                                <Button
                                  className={'active payment-btn'}
                                  onClick={() =>
                                    window.open(
                                      paymentDetails
                                        ?.filter(
                                          (i) =>
                                            i?.payment_method ===
                                            onlinePaymentOption
                                        )[0]
                                        ?.payment_method_details?.upi_intent.replace(
                                          'upi',
                                          'paytmmp'
                                        )
                                    )
                                  }
                                >
                                  <img
                                    className={'payment-icon'}
                                    alt="paytm"
                                    src={paytm}
                                    loading="lazy"
                                    height={30}
                                  />
                                </Button>

                                <div className="payment-detail">
                                  <a
                                    href={
                                      paymentDetails?.filter(
                                        (i) =>
                                          i?.payment_method ===
                                          onlinePaymentOption
                                      )[0]?.payment_method_details?.upi_intent
                                    }
                                  >
                                    {langData?.['pay_through_upi_app']}
                                  </a>
                                </div>
                              </>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {paymentDetails?.length > 0 &&
                      paymentDetails[0]?.payment_method &&
                      onlinePaymentOption === 'BANK_TRANSFER' ? (
                        <>
                          <div className="account-input">
                            <div className="account-label">
                            {langData?.['enter_reference_id']}
                            </div>
                            <TextField
                              required
                              className="acc-input"
                              placeholder={langData?.['enter_utr_txt']}
                              value={referenceId}
                              onChange={(e) => setReferenceId(e.target.value)}
                            />
                          </div>

                          <div className="account-input">
                            <div className="account-label">
                            {langData?.['select_payment_option']}
                            </div>
                            <select
                              required
                              value={paymentOptionFilter}
                              placeholder={langData?.['select_one']}
                              className="acc-input"
                              onChange={(e) =>
                                setPaymentOptionFilter(e.target.value)
                              }
                            >
                              <option value="IMPS">{langData?.['imps']}</option>
                              <option value="NEFT">{langData?.['neft']}</option>
                              <option value="RTGS">{langData?.['rtgs']}</option>
                            </select>
                          </div>

                          <div className="account-input">
                            {depositImage ? (
                              <>
                                <div>
                                  <div className="uploaded-image-title">
                                  {langData?.['uploaded_image']}
                                  </div>
                                  <img
                                    src={`${depositImage}`}
                                    className="deposit-image"
                                  />
                                </div>
                              </>
                            ) : null}

                            <input
                              accept="image/*"
                              style={{ display: 'none' }}
                              id="raised-button-file-abcmoney"
                              multiple
                              hidden
                              type="file"
                              ref={hiddenFileInput}
                              onChange={(e) => handleCapture(e)}
                            />
                            <Button
                              component="div"
                              className="upload-btn"
                              onClick={handleClick}
                            >
                              {langData?.['upload_image']}
                            </Button>
                          </div>
                        </>
                      ) : null}

                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        disabled={loading ? true : false}
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                      >
                        {langData?.['confirm_payment']}
                      </Button>
                    </form>
                  )}
              </>
            ) : (
              <div>{langData?.['providers_not_found_txt']}</div>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={5}>
            <ZenpayCrypto
              setLoading={setLoading}
              loading={loading}
              copyText={copyText}
              tabValue={tabValue}
              index={5}
            ></ZenpayCrypto>
          </TabPanel>
            <BlazePe
              index={6}
              tabValue={tabValue}
              depositAmount={depositAmount}
              loading={loading}
              mobileNumber={mobileNumber}
              providerRefId={providerRefId}
              setDepositAmount={setDepositAmount}
              setMobileNumber={setMobileNumber}
              submitBlazepeDeposit={submitBlazepeDeposit}
              providersList={providersList}
              onlinePaymentOption={onlinePaymentOption}
            />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setOpenDepositModal: (val) => dispatch(setOpenDepositModal(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Deposit);
